export default __webpack_public_path__ + "static/media/ball.7886d0cd.png";